module.exports = __webpack_public_path__ + "custom-config/img/header_info_tv.71388ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/info/header_info_tv.jpg
// module id = LmUC
// module chunks = 2 3 4 6 7 8 9